import { render, staticRenderFns } from "./SideColumn.vue?vue&type=template&id=6b6f20ab&lang=html&"
import script from "./SideColumn.vue?vue&type=script&lang=js&"
export * from "./SideColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/centro-custo/SideColumn.vue
// module id = 1109
// module chunks = 28